import React from 'react';

const ScreenReaderContent = ({ children }) => (
  <span className="sr-only">{children}</span>
);

export default ScreenReaderContent;